export const defaultGtm = () => ({
	funnelPage: {
		event: 'fac_button_click',
		category: 'vuejs-funil-vendas',
		action: 'click',
		label: 'Alternar para Lista de Clientes',
	},
	searchDeal: {
		event: 'fac_button_click',
		category: 'vuejs-funil-vendas',
		action: 'click',
		label: 'Buscar Cliente',
	},
	addDeal: {
		event: 'fac_button_click',
		category: 'vuejs-funil-vendas',
		action: 'click',
		label: 'Adicionar Cliente',
	},
	clearFilters: {
		event: 'fac_button_click',
		category: 'vuejs-funil-vendas',
		action: 'click',
		label: 'Limpar Filtros',
	},
	funnelConfig: {
		event: 'fac_button_click',
		category: 'vuejs-funil-vendas',
		action: 'click',
		label: 'Configurações Gerais do Funil',
	},
	stageStatus: {
		event: 'fac_button_click',
		category: 'vuejs-funil-vendas',
		action: 'click',
		label: 'Etapas e Status',
	},
	idleRules: {
		event: 'fac_button_click',
		category: 'vuejs-funil-vendas',
		action: 'click',
		label: 'Regras de Ociosidade',
	},
	funnelActions: {
		event: 'fac_button_click',
		category: 'vuejs-funil-vendas',
		action: 'click',
		label: 'Ações do Funil',
	},
})
